import { connect } from 'react-redux';
import { goToAdd } from '../ManageServices.saga';
import AddButton from './AddButton';

const mapDispatchToProps = {
  handleAddClick: goToAdd,
};

export default connect(null, mapDispatchToProps)(AddButton);
